import http from '../jslibs/axios/http';

//获取所有路由列表
export const routerlist = () => http.get('/cms/AdminAuthMenu');

//创建路由
export const newrouter = data => http.post('/cms/AdminAuthMenu', data);

//删除权限
export const deletePermission = uuid => http.delete(`/cms/AdminAuthMenu/${uuid}`);

//编辑路由
export const editrouter = data => http.put(`/cms/AdminAuthMenu/${data.id}`, data);